import { useLoad } from '@gogame/query';

import { loadNotificationsSettings } from '../source/notificationsSettings';
import { notificationSettings } from './queryKeyFactory';

export const useLoadNotificationSettings = () => {
  return useLoad(notificationSettings(), () => loadNotificationsSettings());
};
